import api from './api';

/**
 * billing-service's v2 GraphQL surface, through the public API's supergraph at
 * `${PUBLICAPI_URL}/graphql` (the same endpoint app's Apollo client uses). `api`
 * already carries the Bearer token from the access-token cookie. GraphQL errors
 * come back as 200s, so they are raised here like any other failure.
 */
const gql = async (query, variables) => {
  const { data } = await api.post('/graphql', { query, variables });
  if (data.errors?.length) {
    // billing-service codes a decline PAYMENT_REQUIRED, a bad plan value BAD_REQUEST,
    // no live subscription NOT_FOUND, a Recurly outage RECURLY_UNAVAILABLE (BIO-2154).
    const [{ message, extensions }] = data.errors;
    throw Object.assign(new Error(message), { code: extensions?.code });
  }

  return data.data;
};

const CHANGE_PLAN = `mutation ChangePlan($input: ChangePlanInput!) {
  changePlan(input: $input) { planCode productKey state trialEnd }
}`;

/**
 * Moves the company's subscription onto `planCode` (BIO-2154). `planCode` is the sellable
 * list's `value` for the plan at the company's band, the string convert takes. `NOW` during the
 * trial is free and keeps the trial end; `RENEWAL` schedules the change for the next bill.
 */
export const changePlan = (companyId, planCode, timeframe = 'NOW') =>
  gql(CHANGE_PLAN, { input: { companyId, planCode, timeframe } }).then(
    (data) => data.changePlan
  );

const SUBSCRIPTION_STATE = `query BillingSubscriptionState($companyId: ID!) {
  billingSubscription(companyId: $companyId) { state }
}`;

/** The Recurly subscription's state (`TRIALING`, `ACTIVE`, ...), or null when there is none. */
export const subscriptionState = (companyId) =>
  gql(SUBSCRIPTION_STATE, { companyId }).then(
    (data) => data.billingSubscription?.state ?? null
  );

export default { changePlan, subscriptionState };
